import { render, staticRenderFns } from "./TagsDetails.vue?vue&type=template&id=d1955f80&scoped=true&"
import script from "./TagsDetails.vue?vue&type=script&lang=js&"
export * from "./TagsDetails.vue?vue&type=script&lang=js&"
import style0 from "./TagsDetails.vue?vue&type=style&index=0&id=d1955f80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1955f80",
  null
  
)

export default component.exports